import mapValues from 'lodash/mapValues';
import { map } from 'rxjs/operators';

import {
  getBrowseCategoryConfig,
  getBrowseConfig,
  getCategoryConfigs as fetchCategoryConfigs,
  getCategoryConfig as fetchCategoryConfig,
  saveCategoryConfig as postCategoryConfig
} from 'app/api/BrowseApi';
import BrowseConstants from 'app/constants/BrowseConstants';
import { mapCatalogRecordBibToDisplayBib } from 'app/helpers/displayBib';

const fetchBrowseConfig = () => {
  return {
    types: [
      BrowseConstants.FETCH_BROWSE_REQUEST,
      BrowseConstants.FETCH_BROWSE_SUCCESS,
      BrowseConstants.FETCH_BROWSE_FAILURE
    ],
    apiRequest: (_state, apiClient) => getBrowseConfig(apiClient)
  };
};

const fetchCategoryUiConfig = ({ categoryId, postSuccess }) => {
  return {
    apiRequest: (_state, apiClient) => {
      return getBrowseCategoryConfig(apiClient, categoryId).pipe(
        map(res => {
          const { body } = res;
          const { bibsByCategoryId = {} } = body;

          const displayBibsByCategoryId = mapValues(bibsByCategoryId, bibs =>
            bibs.map(mapCatalogRecordBibToDisplayBib)
          );

          return { body: { ...res.body, bibsByCategoryId: displayBibsByCategoryId } };
        })
      );
    },
    postSuccess,
    types: [
      BrowseConstants.FETCH_BROWSE_CATEGORY_REQUEST,
      BrowseConstants.FETCH_BROWSE_CATEGORY_SUCCESS,
      BrowseConstants.FETCH_BROWSE_CATEGORY_FAILURE
    ]
  };
};

// * Experimental *
// Our project includes the redux-thunk middleware: https://redux.js.org/usage/writing-logic-thunks
// However, we don't seem to use it. The main reason seems to be that the apiRequestMiddleware
// handles asynchronous API requests - the primary use-case for thunks.
// Note that these thunks do not dispatch any additional actions.
// They are essentiallly using Redux to get the `apiClient`, but not storing any data in Redux.
const getCategoryConfig = categoryConfigId => {
  return (_dispatch, _getState, apiClient) => fetchCategoryConfig(apiClient, categoryConfigId).toPromise();
};

const getCategoryConfigs = topLevelCategoryId => {
  return (_dispatch, _getState, apiClient) => fetchCategoryConfigs(apiClient, topLevelCategoryId).toPromise();
};

const saveCategoryConfig = categoryConfig => {
  return (_dispatch, _getState, apiClient) => postCategoryConfig(apiClient, categoryConfig).toPromise();
};

export { fetchBrowseConfig, fetchCategoryUiConfig, getCategoryConfig, getCategoryConfigs, saveCategoryConfig };
